import React from 'react';
import { Button } from '@/components/ui/button';
import { Settings, Trophy } from 'lucide-react';
import { League } from '@/types/user';
import { AddUserIcon } from '../icons/AddUserIcon';

interface LeagueCardProps {
  league: League;
  onViewLeaderboard: () => void;
  onAddUser: () => void;
  onSettings: () => void;
  className?: string;
}

const LeagueCard: React.FC<LeagueCardProps> = ({
  league,
  onViewLeaderboard,
  onAddUser,
  onSettings,
  className = '',
}) => {
  const gradientClass = league.color === 'orange' ? 'gradient-orange' : 'gradient-blue';

  return (
    <div
      className={`${gradientClass} rounded-xl p-6 relative overflow-hidden ${className}`}
      data-test-id={`league-card-${league.name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Background Pattern */}
      {league.isOwner && (
        <div className="absolute inset-0 opacity-50">
          <button aria-label="Add user" onClick={onAddUser} className="absolute top-2 left-2">
            <AddUserIcon className="w-6 h-6" />
          </button>
          <button className="absolute top-2 right-2" onClick={onSettings} aria-label="Settings">
            <Settings
              data-test-id="league-settings-btn"
              className="w-6 h-6 text-white cursor-pointer hover:opacity-80 transition-opacity"
            />
          </button>
        </div>
      )}

      {/* Content */}
      <div className="relative z-10">
        <div className="mb-4">
          <h3 className="text-white font-bold text-xl mb-2 text-center">{league.name}</h3>
        </div>

        <div className="flex justify-center">
          <Button
            data-test-id="league-leaderboard-btn"
            variant="secondary"
            onClick={onViewLeaderboard}
            className="bg-white/20 hover:bg-white/30 text-white border-none backdrop-blur-sm gap-2"
          >
            <Trophy className="w-4 h-4" />
            Leaderboard &gt;
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LeagueCard;
